import api, { ResponseCallback } from '../services/api.service'
import routeUtil from '../utils/route.util'
import { AddressData } from './address.api'
import { TimezoneData } from './timezone.api'

export type Status = 'email unverified' | 'email verified' | 'approved' | 'rejected' | 'expired' | 'onboarded' | 'closed'
export type TrialType = 'regular' | 'customLabel' | 'productionCustomLabel'

export interface TrialData {
  id: number
  timezoneId: number
  addressId: number
  type: TrialType
  name: string
  role: string
  username: string
  email: string
  phone: string
  organization: string
  status: Status
  expireAt: string
  createdAt: string
  updatedAt: string
  timezone?: TimezoneData
  address?: AddressData
}

export interface TrialCreateRequest {
  type?: TrialType
  fullName?: string
  role?: string
  username?: string
  email?: string
  phone?: string
  organizationName?: string
  timezone?: string
  address?: string
  city?: string
  state?: string
  zip?: string
}

export interface TrialVerifyEmailRequest {
  token?: string
}

export interface TrialVerifyEmailResponse {
  verified: boolean
}

export interface TrialApproveResponse {
  approved: boolean
}

export interface TrialRejectResponse {
  rejected: boolean
}

export interface TrialOnboardResponse {
  onboarded: boolean
}

export interface TrialCloseResponse {
  closed: boolean
}

const routes = {
  list: '/trials',
  create: '/trials',
  verifyEmail: '/trials/emailVerify',
  approve: '/trials/{id}/approve',
  reject: '/trials/{id}/reject',
  onboard: '/trials/{id}/onboard',
  close: '/trials/{id}/close'
}

export default {
  list (callback: ResponseCallback<TrialData[]>) {
    api.get(routes.list, {}, callback)
  },

  create (
    payload: TrialCreateRequest,
    callback: ResponseCallback<TrialData>
  ) {
    api.postForm(routes.create, payload, callback)
  },

  verifyEmail (
    payload: TrialVerifyEmailRequest,
    callback: ResponseCallback<TrialVerifyEmailResponse>
  ) {
    api.post(routes.verifyEmail, payload, callback)
  },

  approve (
    id: number,
    callback: ResponseCallback<TrialApproveResponse>
  ) {
    const url = routeUtil.replaceParams(routes.approve, { id })
    api.post(url, {}, callback)
  },

  reject (
    id: number,
    callback: ResponseCallback<TrialRejectResponse>
  ) {
    const url = routeUtil.replaceParams(routes.reject, { id })
    api.post(url, {}, callback)
  },

  onboard (
    id: number,
    callback: ResponseCallback<TrialOnboardResponse>
  ) {
    const url = routeUtil.replaceParams(routes.onboard, { id })
    api.post(url, {}, callback)
  },

  close (
    id: number,
    callback: ResponseCallback<TrialCloseResponse>
  ) {
    const url = routeUtil.replaceParams(routes.close, { id })
    api.post(url, {}, callback)
  }
}
